module.exports = __webpack_public_path__ + "front/img/27_10.05d07f26.png";